module.exports = __webpack_public_path__ + "static/img/morenimg.6546275.png";


//////////////////
// WEBPACK FOOTER
// ./static/morenimg.png
// module id = njxm
// module chunks = 1